import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/material';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { Observable,  startWith, switchMap, tap } from 'rxjs';
import { NgFor, AsyncPipe, NgForOf } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'mat-autocomplete-type',
    standalone: true,
    imports: [
        NgFor,
        AsyncPipe,
        MatAutocompleteModule,
        FormlyModule,
        MatInputModule,
        ReactiveFormsModule,
        MatFormFieldModule
    ],
    template: `
    @if (formState.editMode) {
    <input
      matInput
      [matAutocomplete]="auto"
      [attr.aria-label]="props.label"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [placeholder]="props.placeholder"
      [errorStateMatcher]="errorStateMatcher"
      (keydown)="onKeydown($event)"
    />
    <mat-autocomplete #auto="matAutocomplete"
    [autoActiveFirstOption]="true"
    [autoSelectActiveOption]="true"
    [hideSingleSelectionIndicator]="true"
    [displayWith]="displayFn.bind(this)"
    (optionSelected)="onOptionSelected($event)"
    (optionActivated)="onOptionActivated($event)">
      <mat-option *ngFor="let option of filter | async" [value]="option">
        {{ option.label ? option.label : (option.value ? option.value : '') }}
      </mat-option>
    </mat-autocomplete>
    }@else{
    <p>{{getValue()}}</p>
    }

  `,
})
export class MatAutocompleteTypeComponent extends FieldType<FieldTypeConfig> implements OnInit {
    filter: Observable<any>;

    highlightedOption: any;

    displayFn(option: any): string {
        if (typeof option=='string'){
            return option
        }
        if (option) {
            return option.label ? option.label : (option.value ? option.value : '')
        }
    }

    onOptionActivated(event: any) {
        this.highlightedOption = event.option ? event.option.value : null;
    }

    onKeydown(event: KeyboardEvent) {
        if (event.key === 'Tab' && this.highlightedOption) {
          this.formControl.setValue(this.highlightedOption);
          this.props?.optionSelected && this.props.optionSelected(this.highlightedOption, this.field);
        }
    }

    onOptionSelected(selected: MatAutocompleteSelectedEvent) {

        /*
        const selectedOption = selected.option.value;
        if (!this.options.some(option => option.name === selectedOption.name)) {
          // Aggiungi l'opzione come nuova se non è nella lista
          this.options.push({ id: this.options.length + 1, name: selectedOption });
        }*/

        this.props?.optionSelected && this.props.optionSelected(selected.option.value,this.field)
    }

    getValue(){
        const value = this.field.formControl.value;
        if (!value){
            return ''
        }
        if (typeof value=='string'){
            return value
        }
        return value?.label || value.value
    }

    ngOnInit() {

        if (!this.props.filter) return
        this.filter = this.formControl.valueChanges.pipe(
            startWith(''),
            switchMap((term) => this.props.filter(term)),
        );

    }
}
